<template>
  <div class="job-row d-flex align-center py-2">
    <div class="job-row__preview mr-3 flex-shrink-0">
      <v-img
        v-if="previewUrl"
        :src="previewUrl"
        cover
        width="52"
        height="52"
        class="rounded"
      />
      <div v-else class="job-row__placeholder rounded d-flex align-center justify-center">
        <v-icon small color="grey">{{ placeholderIcon }}</v-icon>
      </div>
    </div>

    <div class="job-row__content flex-grow-1 min-width-0 mr-3">
      <div class="text-body-2 font-weight-medium text-truncate">{{ modelName }}</div>
      <div class="text-caption text-medium-emphasis text-truncate">{{ subtitle }}</div>
      <div class="text-caption text-disabled">{{ createdAt }}</div>
    </div>

    <div class="job-row__status flex-shrink-0 text-right" style="min-width: 96px;">
      <template v-if="queued">
        <v-chip size="x-small" variant="outlined" color="grey">{{ $t('myassets.jobs.waiting') }}</v-chip>
      </template>
      <template v-else>
        <v-progress-linear
          :model-value="job.progress || 0"
          height="8"
          rounded
          color="primary"
          class="mb-1"
        />
        <div class="text-caption">{{ Math.round(job.progress || 0) }}%</div>
      </template>
    </div>
  </div>
</template>

<script>
import { primaryAssetId } from '@/components/myassets/myAssetsJobUtils';

export default {
  name: 'MyAssetsJobRow',
  props: {
    job: { type: Object, required: true },
    category: { type: String, required: true },
    assetPreviews: { type: Object, default: () => ({}) },
    modelName: { type: String, required: true },
    subtitle: { type: String, default: '' },
    queued: { type: Boolean, default: false },
  },
  computed: {
    previewUrl() {
      const assetId = primaryAssetId(this.job);
      if (!assetId) {
        return null;
      }
      return this.assetPreviews[assetId] || null;
    },
    placeholderIcon() {
      return this.category === 'run_model' ? 'far fa-circle-play' : 'fas fa-wand-magic-sparkles';
    },
    createdAt() {
      return this.job.created_at || '';
    },
  },
};
</script>

<style scoped>
.job-row + .job-row {
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}

.job-row__placeholder {
  width: 52px;
  height: 52px;
  background: #f5f5f5;
}

.min-width-0 {
  min-width: 0;
}
</style>
